import { SharedExperienceProps, getStrings } from "@microsoft/shifts-experiences-shared";
import {
    Button,
    Dismiss20Regular,
    DrawerBody,
    DrawerHeader,
    DrawerHeaderTitle,
    FluentProvider,
    OverlayDrawer
} from "@microsoft/shifts-ui-core";
import { observer } from "mobx-react";
import * as React from "react";

import {
    useDrawerProps,
    useSchedulingRulesDataProps,
    useSettingsButtonProps
} from "./SchedulingRulesPanel.mappers";
import { useStyles } from "./SchedulingRulesPanel.styles";
import { ConstraintsList } from "./components/ConstraintsList";

/**
 * Renders the scheduling rules panel.
 * @param props The properties.
 * @returns The scheduling rules panel.
 */
export const SchedulingRulesPanel: React.FC<SharedExperienceProps> = observer(props => {
    const styles = useStyles();
    const drawerProps = useDrawerProps();
    const settingsButtonProps = useSettingsButtonProps();
    const schedulingRulesDataProps = useSchedulingRulesDataProps();

    return (
        <FluentProvider theme={props.theme}>
            <OverlayDrawer {...drawerProps}>
                <DrawerHeader className={styles.header}>
                    <DrawerHeaderTitle action={
                        <Button
                            appearance="subtle"
                            icon={<Dismiss20Regular />}
                            onClick={drawerProps.onOpenChange}
                            aria-label={getStrings("common", "close")}
                        />
                    }>
                        {getStrings("schedulingConstraints", "panelTitle")}
                    </DrawerHeaderTitle>
                </DrawerHeader>
                <DrawerBody className={styles.body}>
                    <ConstraintsList
                        constraints={schedulingRulesDataProps}
                        settingsButtonProps={settingsButtonProps}
                    />
                </DrawerBody>
            </OverlayDrawer>
        </FluentProvider>
    );
});